module.exports = __webpack_public_path__ + "media/assets/icons/triangle-left-e39591c4ae521ea6790a697ac8e3cef6.svg";